import { Col, Divider, Form, Row } from 'antd';
import { FormInstance } from 'antd/lib/form';
import FormListAddRemove from '../../../../common/utils/FormListAddRemove';
import BillingIsDeleted from '../../../Invoice(Visa)/Components/BillingIsDeleted';
import { IInvoiceTourOtherTrans } from '../../Types/InvoiceTourTypes';
import OtherTransportForm from './OtherTransportForm';

type Props = {
  form: FormInstance<any>;
  invComClientInfo?: string;
  tourOther?: IInvoiceTourOtherTrans[] | undefined;
};

const InvoiceTourOtherTransportForm = ({ form, invComClientInfo, tourOther }: Props) => {
  return (
    <>
      <Form.List name='tourOtherTrans' initialValue={[{}]}>
        {(fields, { add, remove }) =>
          fields.map((field, index) => {
            return (
              <Row
                gutter={[10, 0]}
                key={index}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyItems: 'center',
                }}
              >
                <Col md={23}>
                  <>
                    {index !== 0 ? (
                      <Divider
                        orientation='left'
                        style={{ borderColor: '#44403C' }}
                      >{`Tour Other-transport Information 🚠 #${index + 1}`}</Divider>
                    ) : (
                      ''
                    )}
                    <OtherTransportForm form={form} field={field} index={index} />
                  </>
                </Col>
                <Col md={1}>
                  <BillingIsDeleted name={[field.name, 'other_trans_is_deleted']} />
                  <FormListAddRemove
                    add={add}
                    index={index}
                    name={field.name}
                    remove={remove}
                    form={form}
                    dataLength={tourOther?.length}
                    NamePath={['tourOtherTrans', field.name, 'other_trans_is_deleted']}
                  />
                </Col>
              </Row>
            );
          })
        }
      </Form.List>
    </>
  );
};

export default InvoiceTourOtherTransportForm;
